module.exports = __webpack_public_path__ + "media/workplace/rating-excellent-fill-ac5654b2.svg";